/** AgentEmail (AgentMail) inbox provisioning status for the Email responsibility channel. */
export type AgentEmailInboxFields = {
  emailType?: string | null;
  agentMailInboxId?: string | null;
  usedEmailPrefix?: string | null;
  usedEmailDomain?: string | null;
};

function resolveCustomSendingEmail(
  fields: AgentEmailInboxFields | null | undefined,
): string | null {
  if (!fields || fields.emailType !== "custom") return null;
  const prefix = fields.usedEmailPrefix?.trim();
  const domain = fields.usedEmailDomain?.trim();
  if (prefix?.includes("@")) return prefix;
  if (prefix && domain) return `${prefix}@${domain}`;
  return null;
}

/** AgentMail inbox address only (Email channel provisioned). */
export function resolveAgentEmailAddress(
  fields: AgentEmailInboxFields | null | undefined,
): string | null {
  if (!fields || fields.emailType !== "agentmail" || !fields.agentMailInboxId?.trim()) {
    return null;
  }
  const prefix = fields.usedEmailPrefix?.trim();
  const domain = fields.usedEmailDomain?.trim();
  if (prefix?.includes("@")) {
    return prefix.replace(/(@agentmail\.to)(@agentmail\.to)+$/gi, "$1");
  }
  if (prefix && domain) {
    return `${prefix}@${domain}`;
  }
  return null;
}

/**
 * Public Agent Profile / CV display email: AgentMail when provisioned, else marketplace
 * hire custom sending address (e.g. no-reply@easygpt.builders).
 */
export function resolveDisplayAgentEmail(
  fields: AgentEmailInboxFields | null | undefined,
): string | null {
  return resolveAgentEmailAddress(fields) ?? resolveCustomSendingEmail(fields);
}

export function isEmailInboxProvisioned(
  fields: AgentEmailInboxFields | null | undefined,
): boolean {
  return !!resolveAgentEmailAddress(fields);
}
